export default __webpack_public_path__ + "static/form-stack-diagram-3a6275426c115200171bc3a6fa490ed3.png";